import * as React from "react";
import { Provider } from "mobx-react";
import ReactDOM from "react-dom";
import { WsConfiguration } from "./WsConfiguration";
import WsConnection from "./WsConnection";
import NotificationsButton from "../Notifications/NotificationsButton";
import WsHandlers from "./WsHandlers";
import Stores from "../Stores/Stores";
import AwaitingHandoverModal from "../Handovers/AwaitingHandoverModal";
import { ToastContainer } from "react-toastify";
import SessionTimeoutModal from "../SessionTimeoutModal/SessionTimeoutModal";

export default class WsRoot extends React.Component {
  configuration: WsConfiguration;
  connection: WsConnection = new WsConnection();
  wsHandlersRef: React.RefObject<WsHandlers>;

  constructor(props: any) {
    super(props);

    this.state = {};
    this.wsHandlersRef = React.createRef();
  }

  startWithConfiguration = async (config: WsConfiguration): Promise<boolean> => {
    config = Object.assign(new WsConfiguration(), config);
    if (!config.validateConfiguration()) {
      return false;
    }

    this.configuration = config;

    Stores.sharedValues.init();
    await Stores.sharedValues.getValues();

    this.getWsHandlers().subscribeAll();
    this.renderNotifications();

    this.triggerRender();
    return this.connection.start(config);
  };

  stop = () => {
    this.getWsHandlers().unsubscribeAll();
    this.connection.stop();
  };

  sendMessage = (type: string, data?: object) => {
    this.connection.sendMessage(type, data);
  };

  componentWillUnmount() {
    this.stop();
  }

  getWsHandlers() {
    return this.wsHandlersRef.current;
  }

  renderNotifications = () => {
    if (!this.configuration.notifications || !this.configuration.notifications.rootElementId) {
      return;
    }

    let root = document.getElementById(this.configuration.notifications.rootElementId);
    if (!root) {
      return;
    }

    ReactDOM.render(
      <Provider {...Stores}>
        <NotificationsButton configuration={this.configuration.notifications} />
      </Provider>,
      root
    );
  };

  triggerRender() {
    this.setState({ state: this.state });
  }

  render() {
    return (
      <Provider {...Stores}>
        <div>
          <ToastContainer draggable={false} />
          <WsHandlers ref={this.wsHandlersRef} />
          <AwaitingHandoverModal configuration={this.configuration ? this.configuration.handovers : null} />
          <SessionTimeoutModal />
        </div>
      </Provider>
    );
  }
}
